export default function Section5() {
  return (
    <div className="Section5">
      <div className="section5-container my-[7%] px-5 md:my-0 md:mt-[68px] md:px-[30px] md:justify-evenly md:items-center md:flex">
        <div className="md:w-[36%]">
          <h2 className="text-[24px] md:text-[34px] pb-[2%] leading-[32px] md:leading-[41px] font-bold text-[#DA2128] my-[0.67em]">
            Get Started Today
          </h2>

          <p className="leading-[20px] text-[#373737] pb-[1%] text-[16px] mb-5 font-open">
            Ready to harness the power of email marketing? Contact us today for
            a free consultation. Let's work together to create an email
            marketing strategy that drives growth, engages your audience, and
            achieves your business goals.
            <br />
            Don't miss out on the opportunities that email marketing can bring
            to your business. Join hands with Mean3 and start your journey
            toward email marketing success
          </p>
        </div>

        <div className="w-full img-cont md:w-auto">
          <img
            className="w-full md:w-auto"
            src="../../../assets/start-image-email-marketing.png"
          ></img>
        </div>
      </div>

      <div className="line mx-auto mt-[20px] mb-[55px] md:mb-[4%] md:mt-[5%] w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
